import { css } from "emotion";
import { H1 } from "../../../components/text/TextComponents";

const banner = css({
  position: "relative",
  backgroundColor: "#f9f9fa",
  maxWidth: "100%",
  height: 300,
  paddingTop: 64,
  textAlign: "center",
  h1: {
    fontSize: 36
  },
  "@media(max-width: 550px)": {
    paddingTop: 34,
    height: 160,
    h1: {
      fontSize: 22
    }
  }
});

const bannerPinkText = css({
  width: 485,
  height: 106,
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  "@media(max-width: 550px)": {
    width: 170,
    height: 40
  }
});

const bannerPageCorner = css({
  position: "absolute",
  bottom: 0,
  right: 0,
  "@media(max-width: 550px)": {
    width: 54,
    height: 58
  }
});

const imagePinkText = require("../../../assets/image_pink_text.svg");
const imagePageCorner = require("../../../assets/image_paper_corner.svg");

const Banner = ({}) => {
  return (
    <div className={banner}>
      <H1 marginBottom={24} marginBottomMobile={14}>
        Our Story
      </H1>
      <img className={bannerPinkText} src={imagePinkText} alt="Pink ellipses" />
      <img
        className={bannerPageCorner}
        src={imagePageCorner}
        alt="Doggy eared corner"
      />
    </div>
  );
};

export default Banner;
